import * as React from "react";
import { GridCoreState } from "./components/types";

export interface GridMemoryContextInterface {
  memory: { [name: string]: GridCoreState };
  setMemory: (data: {}) => void;
}

const defaultMemory: GridMemoryContextInterface = {
  memory: {},
  setMemory: () => {}
};

export const GridMemoryStateContext = React.createContext(defaultMemory);

export const GridMemoryProvider = ({ children }) => {
  const [memory, setMemory] = React.useState({});

  const value = { memory, setMemory };

  return <GridMemoryStateContext.Provider value={value} children={children} />;
};

export const useGridMemory = () => React.useContext(GridMemoryStateContext);
